// extracted by mini-css-extract-plugin
export var deliveryRow = "_lm-a";
export var fixedHeight = "_lm-4";
export var freightLogo = "_lm-9";
export var fullWidth = "_lm-3";
export var priceColumn = "_lm-5";
export var radioSelected = "_lm-7";
export var radioUnselected = "_lm-6";
export var selectedOption = "_lm-2";
export var selectedOptionContainer = "_lm-1";
export var selection = "_lm-0";
export var tallSkeletonText = "_lm-8";